"use client"

import { useState } from "react"

import Register from "@modules/account/components/register"
import Login from "@modules/account/components/login"
import { ForgotPassword } from "@modules/account/components/reset-password"

export enum LOGIN_VIEW {
  SIGN_IN = "sign-in",
  REGISTER = "register",
  FORGOT_PASSWORD = "forgot-password",
}

type LoginTemplateProps = {
  /** Page to continue on after signing in (e.g. the checkout) */
  next?: string
  /** Email to prefill */
  email?: string
  initialView?: "register"
}

const LoginTemplate = ({ next, email, initialView }: LoginTemplateProps) => {
  const [currentView, setCurrentView] = useState<LOGIN_VIEW>(
    initialView === "register" ? LOGIN_VIEW.REGISTER : LOGIN_VIEW.SIGN_IN
  )

  return (
    <div className="w-full flex justify-start px-8 py-8">
      {currentView === LOGIN_VIEW.SIGN_IN ? (
        <Login setCurrentView={setCurrentView} next={next} email={email} />
      ) : currentView === LOGIN_VIEW.FORGOT_PASSWORD ? (
        <ForgotPassword
          email={email}
          onBack={() => setCurrentView(LOGIN_VIEW.SIGN_IN)}
        />
      ) : (
        <Register setCurrentView={setCurrentView} next={next} email={email} />
      )}
    </div>
  )
}

export default LoginTemplate
